import React, { useEffect } from "react";
import BackendLayout from "../../layouts/BackendLayout";
import { PageTitle } from "../../components/admin";
import { POSITION_MASTER_EXPORT } from "../../constants/routes";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { useDocumentTitle } from "../../hooks";
import { useDispatch } from "react-redux";
import { getPositionExportPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import FileExport from "../../components/file-management/FileExport";
import { API_POSITION_EXPORT } from "../../constants/api";
import {ButtonExport, RedirectAlert} from "../../components";
import { clearPageLoading, setPageLoading } from "../../store/actions";
import {POSITION_MASTER_EXPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

export default function PositionExportPage() {
  useRedirectPage(POSITION_MASTER_EXPORT_PAGE);
  useDocumentTitle("職位マスタエクスポート - 点検王");
  const breadcrumb = getRouteBreadcrumb(POSITION_MASTER_EXPORT);
  const dispatch = useDispatch();

  const setPositionExportPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getPositionExportPageSettings();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };

  useEffect(() => {
    setPositionExportPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="職位マスタエクスポート" />
      <RedirectAlert />
      <FileExport
        title="現在の職位マスタの状態をファイル出力します"
        description="職位データをExcelファイルとしてエクスポートするために、以下のボタンを押してください。"
        apiUrl={API_POSITION_EXPORT}
      >
        <ButtonExport
          buttonColor="yellow"
          iconColor="616161"
          description="全ての職位を含む"
          borderColor="tenken__border-gray-500"
          descriptionTextColor="text-tenken-gray-900"
          titleTextColor="text-tenken-gray-700"
          apiUrl={API_POSITION_EXPORT}
          id='button__export-position'
        />
      </FileExport>
    </BackendLayout>
  );
}
